module.exports = __webpack_public_path__ + "static/media/InfoAlert.09acf505.svg";